const consumoV2 = () => import('./ConsumoV2.vue');

export default [
  {
    path: '/medicoes/consumoV2',
    name: 'consumoV2',
    component: consumoV2
  }
];
